import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import {
    selectApplicationContinueData,
    selectApplicationContinueStatus,
    selectApplicationContinueError,
    initializeAsync,
} from "./applicationContinueSlice";
import { Button, Container, Divider, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { continueFromStart } from "../../utils";

// Add custom imports here

const ApplicationContinue = () => {
    const data = useSelector(selectApplicationContinueData);
    const status = useSelector(selectApplicationContinueStatus);
    const error = useSelector(selectApplicationContinueError);
    const dispatch = useDispatch();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();

    const navigate = useNavigate();

    // Add Variables

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync());
        }
    }, [status, dispatch]);

    const handlePreviousClick = () => {
        navigate("/", {});
    };

    const handleStartClick = () => {
        continueFromStart(userDetails.applicant);
        userDetails.applicant.identityVerifivationSessionId = "";
        userDetails.applicant.plaidIdentityVerified = "";
        userDetails.applicant.identityVerifivationStatus = "";
        userDetails.applicant.plaidOtherVerified = "";
        userDetails.applicant.currentScreen = "";
        userDetails.applicant.currentTab = "";
        setUserDetailsNotAsync(userDetails);
        navigate("/", {});
    };

    let body = (
        <>
            <Container className="ApplicationMethod">
                <Typography variant="h1" component="h1">
                    Alert!
                </Typography>
                <Typography variant="h6" component="h6" sx={{ textAlign: "center" }}>
                    You have an on-going application. Choose one of the below option to continue the application
                </Typography>

                <Button
                    onClick={handlePreviousClick}
                    color="primary"
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ height: "45px" }}
                >
                    Continue from previous location
                </Button>
                <Divider sx={{ width: "46%" }}></Divider>
                <Button
                    onClick={handleStartClick}
                    color="primary"
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ height: "45px", background: "#164C63" }}
                >
                    Continue from Start
                </Button>
            </Container>
        </>
    );

    return getPageContent(body, status, error);
};

export { ApplicationContinue };
